import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';

import { ApiResponse } from '@shared/models/api-response.model';
import { silentHttpContext } from '@shared/http/silent-request.context';
import { DebugHelper } from '@shared/helpers/debug.helper';

import { StatisticApiData } from '../models/statistic-api.model';
import { StatisticPayload } from '../models/statistic.model';

/**
 * Service responsible for sending statistics events to the backend.
 *
 * Calls are fire-and-forget: any error (network, 4xx, 5xx including the
 * documented 406 "statistic key not pre-registered") is swallowed so the
 * UI never reacts to a failed event.
 *
 * `HttpClient` is used directly (instead of `ApiService`) so we can attach
 * the `SILENT_REQUEST` HttpContext token, which tells the global error
 * interceptor to skip the user-facing toast.
 */
@Injectable({ providedIn: 'root' })
export class StatisticsApiService {

  static apiContext = 'statistics';

  private _http = inject(HttpClient);

  put$(payload: StatisticPayload): Observable<ApiResponse<StatisticApiData> | null> {
    return this._http
               .put<ApiResponse<StatisticApiData>>(
                   StatisticsApiService.apiContext,
                   payload.toApi(),
                   { context: silentHttpContext() },
               )
               .pipe(
                   catchError((error) => {
                     DebugHelper.log('[Statistics] put failed', error);
                     return EMPTY;
                   }),
               );
  }
}
